import axios from "axios";
import { Base_URL } from "../url";

// Create new team
export const saveTeam = async (teamData, userId) => {
  try {
    const payload = {
      ...teamData,
      UserName: String(userId),
    };

    const response = await axios.post(
      `${Base_URL}/TeamMaster/CreateTeam`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update team
export const updateTeam = async (teamId, teamData, userId) => {
  try {
    const payload = {
      ...teamData,
      UserName: String(userId),
    };

    const response = await axios.put(
      `${Base_URL}/TeamMaster/UpdateTeam/${teamId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Add team members
export const addTeamMembers = async (teamId, memberIds, userId) => {
  try {
    const payload = {
      MemberIds: memberIds,
      UserName: String(userId),
    };

    const response = await axios.post(
      `${Base_URL}/TeamMaster/AddTeamMembers/${teamId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Remove team members
export const removeTeamMembers = async (teamId, memberIds, userId) => {
  try {
    const payload = {
      MemberIds: memberIds,
      UserName: String(userId),
    };

    const response = await axios.delete(
      `${Base_URL}/TeamMaster/RemoveTeamMembers/${teamId}`,
      {
        data: payload,
      },
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get teams by organization
export const getTeamsByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TeamMaster/GetTeamsByOrg/${orgId}`,
    );

    console.log("Raw API response:", response.data);

    // The response structure: { success: true, data: [...], count: x }
    const teamsData = response.data?.data || [];

    // Transform the data to match what frontend expects
    const transformedTeams = teamsData.map((team) => ({
      teamId: team.teamId,
      teamName: team.teamName,
      orgId: team.orgId,
      teamMembers: team.members?.map((member) => String(member.memberId)) || [],
      createdBy: team.createdBy,
      createdOnDate: team.createdOnDate,
      createdOnTime: team.createdOnTime,
      changedBy: team.changedBy,
      changedOnDate: team.changedOnDate,
      changedOnTime: team.changedOnTime,
      memberCount: team.memberCount,
    }));

    console.log("Transformed teams:", transformedTeams);
    return transformedTeams;
  } catch (error) {
    console.error("Error in getTeamsByOrg:", error);
    throw error.response?.data || error;
  }
};

// Get team by ID
export const getTeamById = async (teamId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TeamMaster/GetTeamDetails/${teamId}`,
    );

    const teamData = response.data?.data || null;

    if (!teamData) return null;

    // Transform the data to match what frontend expects
    return {
      teamId: teamData.teamId,
      teamName: teamData.teamName,
      orgId: teamData.orgId,
      teamMembers:
        teamData.members?.map((member) => String(member.memberId)) || [],
      createdBy: teamData.createdBy,
      createdOnDate: teamData.createdOnDate,
      createdOnTime: teamData.createdOnTime,
      changedBy: teamData.changedBy,
      changedOnDate: teamData.changedOnDate,
      changedOnTime: teamData.changedOnTime,
      memberCount: teamData.memberCount,
    };
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all teams
export const getAllTeams = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TeamMaster/GetAllTeams`);
    const teamsData = response.data?.data || [];

    // Transform the data
    const transformedTeams = teamsData.map((team) => ({
      teamId: team.teamId,
      teamName: team.teamName,
      orgId: team.orgId,
      teamMembers: team.members?.map((member) => String(member.memberId)) || [],
      createdBy: team.createdBy,
      createdOnDate: team.createdOnDate,
      changedBy: team.changedBy,
      changedOnDate: team.changedOnDate,
      memberCount: team.memberCount,
    }));

    return transformedTeams;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get team members
export const getTeamMembers = async (teamId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TeamMaster/GetTeamMembers/${teamId}`,
    );

    const membersData = response.data?.data || null;

    if (!membersData) return null;

    // Return just the member IDs as strings
    return {
      teamId: membersData.teamId,
      teamName: membersData.teamName,
      memberIds: membersData.members?.map((m) => String(m.memberId)) || [],
      memberCount: membersData.memberCount,
    };
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get teams with members by organization
export const getTeamsWithMembersByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TeamMaster/GetTeamsWithMembersByOrg/${orgId}`,
    );

    console.log("Teams with members response:", response.data);

    // Return the full response data which includes teams with their members
    return response.data?.data || [];
  } catch (error) {
    console.error("Error in getTeamsWithMembersByOrg:", error);
    throw error.response?.data || error;
  }
};
